import MetasInsertForm from "../../components/Metas/MetasInsertForm";




function MetasAdd(){


    return (
        <MetasInsertForm   ></MetasInsertForm>
    );
}
export default MetasAdd;